var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"layer"},[_c('path',{staticClass:"stroke-color",attrs:{"stroke-width":"2","stroke-linecap":"round","stroke":"#055A7F","fill":"none","d":"M12 6l6.007 5.993L12 18"}}),_c('path',{staticClass:"stroke-color",attrs:{"stroke-width":"2","stroke-linecap":"round","stroke":"#055A7F","fill":"none","d":"M6.497 6l6.007 5.993L6.497 18"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }